module.exports = "/src/views/donate/main/elements/shop/img/top_up.png";